"use strict";
/**
 * @ignore
 */

exports.__esModule = true;
exports.providerError = void 0;
/**
 * Create an Error for a provider
 *
 * @param provider - The id of the provider
 * @param msg - The content of the error message
 */

function providerError(provider, msg) {
  return new Error("[" + provider + "] " + msg);
}

exports.providerError = providerError;